var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXdn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#4F7AA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48631 6.75H9.02644C9.77006 6.75 11.0981 7.20169 11.0981 9C11.0981 10.7983 9.77063 11.25 9.02644 11.25H7.48688L7.48631 6.75ZM8.33569 10.3387H8.97356C9.50456 10.3387 10.1419 10.0136 10.1419 9C10.1419 7.98637 9.50456 7.66125 8.97356 7.66125H8.33625L8.33569 10.3387ZM11.6831 6.75H12.0015L14.8691 10.7021V6.75H15.1875V11.25H14.8686L12.0009 7.3845V11.25H11.682L11.6831 6.75ZM2.8125 6.75H3.8745V7.875H2.8125V6.75ZM4.40606 6.75H5.4675V7.875H4.40606V6.75ZM5.99906 6.75H7.06163V7.875H5.99906V6.75ZM5.99906 8.4375H7.06163V9.5625H5.99906V8.4375ZM5.99906 10.125H7.06163V11.25H5.99906V10.125ZM4.40606 8.4375H5.4675V9.5625H4.40606V8.4375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXdn);
export default __webpack_public_path__ + "static/media/xdn.1804b986b1cb9ddfe5948d963acd630e.svg";
export { ForwardRef as ReactComponent };